import type {Ticket} from '../types/ticket';
import {PRIORITY_LABELS} from '../constants/priority';
import {formatCreated} from './formatCreated';
import {slaPresentation} from './slaPresentation';

/**
 * A ticket flattened for the design-system table, which reads each cell through a
 * plain accessor key. Every displayed string is derived here rather than in a cell
 * renderer, so search, sort and export all see the same text the reader does.
 */
export interface TicketTableRow {
	rowId: string;
	slug: string;
	subject: string;
	requesterName: string;
	assigneeName: string;
	priorityLabel: string;
	created: string;
	labelsText: string;
	projectLabel: string;
	slaText: string;
	ticket: Ticket;
}

const EM_DASH = '—';

export function ticketTableRows(tickets: readonly Ticket[], now: Date = new Date()): TicketTableRow[] {
	return tickets.map(ticket => ({
		rowId: ticket.id,
		slug: ticket.slug,
		subject: ticket.subject,
		requesterName: ticket.requester_name ?? EM_DASH,
		assigneeName: ticket.assignee_name ?? 'Unassigned',
		priorityLabel: PRIORITY_LABELS[ticket.priority] ?? EM_DASH,
		created: formatCreated(ticket.created_at, now),
		labelsText: ticket.labels.length > 0 ? ticket.labels.map(label => label.name).join(', ') : EM_DASH,
		// Tickets carry no linked project on the list query yet, so the column holds
		// its place with an em-dash rather than being dropped from the table.
		projectLabel: EM_DASH,
		slaText: slaPresentation(ticket.sla).text,
		ticket,
	}));
}
